import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateNotificationsReadStatusMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationsReadStatusInput;
}>;


export type UpdateNotificationsReadStatusMutation = { __typename?: 'Mutation', updateNotificationsReadStatus?: { __typename?: 'UpdateNotificationsReadStatusPayload', successful: boolean } | null };


export const UpdateNotificationsReadStatus = /*#__PURE__*/ gql`
    mutation UpdateNotificationsReadStatus($input: UpdateNotificationsReadStatusInput!) {
  updateNotificationsReadStatus(input: $input) {
    successful
  }
}
    ` as unknown as DocumentNode<UpdateNotificationsReadStatusMutation, UpdateNotificationsReadStatusMutationVariables>;

          

          export const useUpdateNotificationsReadStatusMutation = (options?:MutationHookOptions<UpdateNotificationsReadStatusMutation, UpdateNotificationsReadStatusMutationVariables>) => useMutation(UpdateNotificationsReadStatus, options);
          

          export type UpdateNotificationsReadStatusMutationOptions = MutationHookOptions<UpdateNotificationsReadStatusMutation, UpdateNotificationsReadStatusMutationVariables>;

          

          export type UpdateNotificationsReadStatusMutationResult = ReturnType<typeof useUpdateNotificationsReadStatusMutation>[1];

          
